import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/dialog-constants";
import { UserDisplay } from "@components/common/user-display";
import { useCompanyId } from "@context-providers/company-id-provider";
import { DeleteIcon, Dialog, MenuItem, Text, Tooltip } from "@flat-ui";
import { useRemoveMemberFromProject } from "@hooks/use-remove-member-from-project";
import { REMOVE_MEMBER_THROUGH_TEAM_MESSAGE } from "@src/constants/team-constants";
import { REMOVE_RESOURCE_OWNER_MESSAGE } from "@src/constants/project-constants";
import { TableType } from "@utils/track-event/track-event-list";
import { useState } from "react";
/**
 * Menu item that removes a member from a single project. Disabled with an
 * explanatory tooltip when the member's access comes through a team or when the
 * member is the project's resource owner.
 */
export function RemoveMemberMenuItem({
  project,
  member,
  isAssignedThroughTeam,
  isResourceOwner,
  onRemoved,
  closeMenu
}) {
  const companyId = useCompanyId();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const {
    removeMember,
    isRemovingMember
  } = useRemoveMemberFromProject({
    companyId,
    project,
    trackingProps: {
      dataType: TableType.projectMembers,
      eventLocation: "member-group-project-menu"
    },
    onRemoved
  });
  function closeDialog() {
    setIsDialogOpen(false);
    closeMenu();
  }
  async function confirmRemove() {
    try {
      await removeMember(member);
    } finally {
      closeDialog();
    }
  }
  const isRemovalDisabled = isAssignedThroughTeam || isResourceOwner;
  const disabledReason = isAssignedThroughTeam ? REMOVE_MEMBER_THROUGH_TEAM_MESSAGE : REMOVE_RESOURCE_OWNER_MESSAGE;
  const menuItem = <MenuItem label="Remove member" Icon={DeleteIcon} disabled={isRemovalDisabled} onClick={() => setIsDialogOpen(true)} />;
  return <>
      {isRemovalDisabled ? <Tooltip component="div" title={disabledReason}>
          {menuItem}
        </Tooltip> : menuItem}

      <Dialog title="Remove from project" confirmText="Remove" open={isDialogOpen} onConfirm={confirmRemove} onCancel={closeDialog} showSpinner={isRemovingMember}>
        <Text variant="bodyM" sx={{
        mb: SPACE_ELEMENTS_OF_MODAL
      }}>
          When removing member from project they will no longer be able to
          access this project. You can always invite this member again.
        </Text>

        <UserDisplay member={member} />
      </Dialog>
    </>;
}